import * as ActionTypes from "../Actions/ActionTypes";
import produce from "immer";
const INITIAL_STATE = {
  isAuth: false,
  userInfo: null,
  loading: true,
  error: true,
  IP: null,
  show: false,
  msg: null,
  msgTitle: null,
};

export const AppReducer = produce((state, action) => {
  const { type } = action;
  switch (type) {
    case ActionTypes.ACTIVATE_LOADER:
      state.loading = action.loading;
      return state;

    case ActionTypes.ACTIVATE_MODAL:
      state.msg = action.msg;
      state.show = action.show;
      return state;
    case ActionTypes.IS_AUTH_REDUCER:
      state.isAuth = action.isAuth;
      state.userInfo = action.userInfo;
      return state;

    default:
      return state;
  }
}, INITIAL_STATE);
